import React from "react";

import { useNavigateToLink } from "./hooks/useNavigateTo";
import type { NavigateToOptions } from "./core";
import { Link, type LinkProps } from "./Link";

export type LinkToProps<TRoute extends string> = Omit<LinkProps, "to"> &
	NavigateToOptions<TRoute> & {
		to: TRoute;
	};

/**
 * A link component that navigates to the given.
 *
 * @see useNavigateToLink
 */
export const LinkTo = React.forwardRef(({ to, params, search, ...props }: LinkToProps<string>, ref) => {
	const link = useNavigateToLink(to, { params, search });

	return <Link ref={ref} to={link} {...props} />;
}) as <TRoute extends string>(props: React.RefAttributes<HTMLAnchorElement> & LinkToProps<TRoute>) => React.ReactNode;
